import { OnDestroy, Directive, Optional, HostBinding } from '@angular/core';
import { Subscription } from 'rxjs';

import { CollapseContainerDirective } from './collapse-container.directive';

@Directive({
  selector: '.collapse-body'
})
export class CollapseBodyDirective implements OnDestroy {

  private collapseStatus$: Subscription;
  @HostBinding('class.collapse') collapsed = false;

  constructor(@Optional() container: CollapseContainerDirective) {
    if (container) {
      this.collapseStatus$ = container.collapseStatus.subscribe((collapsed) => {
        this.collapsed = collapsed;
      });
    }
  }

  ngOnDestroy() {
    if (this.collapseStatus$) {
      this.collapseStatus$.unsubscribe();
    }
  }
}
